import { ListGroup } from 'react-bootstrap';

import './TimelineContextMenu.css';

interface TimelineContextMenuProps {
    show: boolean,
    setShow: any,
    position: any,
    setShowUserAnnotationModal: any,
    resetZoom: any,
}

function TimelineContextMenu({
    show,
    setShow,
    position,
    setShowUserAnnotationModal,
    resetZoom,
}: TimelineContextMenuProps) {

    return show ? (
        <div className="timeline-context-menu" style={{ top: position.y, left: position.x }}>
            <ListGroup>
                <ListGroup.Item action onClick={() => {setShow(false); setShowUserAnnotationModal(true)}}>
                    Add User Annotation
                </ListGroup.Item>
                <ListGroup.Item action onClick={() => {setShow(false); resetZoom()}}>
                    Reset Zoom
                </ListGroup.Item>
            </ListGroup>
        </div>
    ) : <></>;
}

export default TimelineContextMenu;
